/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'platform': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M85.333 725.333h853.248c.256 0 .086-597.333.086-597.333H85.419c-.256 0-.086 597.333-.086 597.333zM0 128c0-47.147 37.973-85.333 85.419-85.333H938.58A85.333 85.333 0 011024 128v597.333c0 47.19-37.973 85.334-85.419 85.334H85.42A85.333 85.333 0 010 725.333V128z"/><path pid="1" d="M725.248 554.667c.085-.171-426.496 0-426.496 0-.085.17 426.496 0 426.496 0zm-469.248 0C256 531.115 275.456 512 298.752 512h426.496a42.624 42.624 0 110 85.333H298.752A42.624 42.624 0 01256 554.667zm298.581-256c.086-.171-255.829 0-255.829 0-.085.17 255.83 0 255.83 0zm-298.581 0C256 275.115 275.456 256 298.752 256h255.83a42.624 42.624 0 110 85.333h-255.83A42.624 42.624 0 01256 298.667zm213.333 426.666h85.334v213.334h-85.334z"/><path pid="2" d="M298.667 896h426.666v85.333H298.667V896z"/>'
  }
})
